// External Imports
import { useEffect, useState } from "react";
import { MdRefresh } from "react-icons/md";

// Internal Imports
import { uploadImageToFirebase } from "../../util/upload-image-to-firebase";
import { toTitleCase } from "../../util/format-text";
import { requestAdminAPI } from "../../api/posh-api";
import { validateImageFile } from "../../util/validate-file";
import DetailPair from "../UI/DetailPair";
import Heading from "../UI/Heading";
import LinkPair from "../UI/LinkPair";

export default function Makes() {


  // Initialize States
  const [loading, setLoading] = useState(false);
  const [makes, setMakes] = useState([]);
  const [logoError, setLogoError] = useState("");

  /* ======================= FETCH MAKES ======================= */
  const fetchRecords = async () => {
    try {
      setLoading(true);
      const res = await requestAdminAPI("fetch-all", {
        table: "make",
      });
      setMakes(res.sort((a, b) => a.name.localeCompare(b.name)));
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  /* ======================= ADD MAKE ======================= */
  const addBrandHandler = async (event) => {
    event.preventDefault();
    try {
      setLoading(true);
      setLogoError("");

      const name = event.target.make.value;
      const file = event.target.logo.files[0];

      // Validate logo file type (PNG, JPG, HEIC)
      if (file) {
        const { isValid, error: validationError } = validateImageFile(
          file,
          "Logo"
        );

        if (!isValid) {
          setLogoError(validationError);
          setLoading(false);
          return;
        }
      }

      const path = `Brands/${name}`;
      const url = await uploadImageToFirebase(path, "logo", file, () => {});

      await requestAdminAPI("add-make", {
        name,
        image: url,
      });

      // Reset form
      event.target.reset();
      setLogoError("");
      fetchRecords();
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRecords();
  }, []);

  return (
    <div className="container gap-8">
      <Heading
        title="Makes"
        text="Before adding a vehicle, make sure that the brand of the vehicle is added to this list. It allows the system to capture brand logos."
      >
        <MdRefresh className="icon" onClick={fetchRecords} />
      </Heading>
      <div className="grid lg:grid-cols-6 grid-cols-2 gap-4 overflow-scroll max-h-[600px] no-scrollbar">
        {makes.map((make, idx) => (
          <div key={idx} className="grid items-center grid-cols-2 text-sm pill">
            <img className="h-8 ml-auto" src={make.image} />
            <p className="text-stone-200">{toTitleCase(make.name)}</p>
          </div>
        ))}
      </div>
      <Heading
        title="Add Make"
        text="Incorrect spellings will cause vehicle make logos to not show and other brand related issues."
        isBackArrow={false}
      />
      <form onSubmit={addBrandHandler} className="items-end info">
        <div>
          <LinkPair
            label="Logo"
            inputOptions={{
              type: "file",
              required: true,
              id: "logo",
              accept: ".png,.webp,.PNG,.WEBP,image/png,image/webp",
            }}
            edit={true}
            loading={loading}
          />
          {logoError && (
            <p className="mt-1 text-xs text-red-400">{logoError}</p>
          )}
        </div>
        <DetailPair
          label="Make"
          inputOptions={{
            type: "text",
            placeholder: "Brand Name",
            required: true,
            id: "make",
          }}
          edit={true}
          loading={loading}
        />
        <button type="submit" className="btn-primary">
          Add Brand
        </button>
      </form>
    </div>
  );
}
